import React from 'react';
import { useMemo } from 'react';

const range = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const usePagination = ({
  totalCount,
  pageSize,
  siblingCount = 1,
  currentPage
}) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);

    /*
      If the number of pages is less than the total number of pages we want to show in our
      pagination component, we return the range [1..totalPageCount]
    */
    if (totalPageCount <= siblingCount + 5) {
      return range(1, totalPageCount);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      totalPageCount
    );

    return range(leftSiblingIndex, rightSiblingIndex);
  }, [totalCount, pageSize, siblingCount, currentPage]);

  return paginationRange;
};
